import React, { useEffect, Fragment, createElement, useState } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  Button,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@material-ui/core";
//svgs
// svgs
import { ReactComponent as FbIcon } from "../images/socialIcons/FbIcon.svg";
import { ReactComponent as WhatsApp } from "../images/socialIcons/WhatsApp.svg";
import { ReactComponent as WeChatIcon } from "../images/socialIcons/WeChatIcon.svg";
import { ReactComponent as LineIcon } from "../images/socialIcons/LineIcon.svg";
import { InlineShareButtons } from "sharethis-reactjs";
import {
  FacebookShareButton,
  LineShareButton,
  WhatsappShareButton,
} from "react-share";

import { useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../components/Alert";
import AspectRatio from "../components/AspectRatio";
import moment from "moment";

const GET_ARTICLE = gql`
  query article($id: Int!) {
    article(id: $id) {
      id
      title
      imageUrl
      type
      createdAt
      contents {
        type
        body
      }
    }
  }
`;

// ANCHOR 組件樣式
const useStyles = makeStyles({
  textBase: { flex: 1 },
  paragraph: {
    textAlign: "justify",
    textJustify: "inter-character",
  },
  image: {
    alignSelf: "center",
    width: "100%",
    maxWidth: 600,
  },
});
export default function NewsContentPage() {
  const isTable = useMediaQuery("(min-width:960px)");
  useEffect(() => {
    if (isTable) {
      window.scrollTo({
        top: 600,
        behavior: "smooth",
      });
    }
  }, [isTable]);
  return (
    <Box>
      <TitleImg />
      <NewsContent />
    </Box>
  );
}

//ANCHOR 標題圖片
function TitleImg() {
  const isTable = useMediaQuery("(min-width:769px)");
  const isPhone = useMediaQuery("(min-width:576px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
    },
    titleImg: {
      width: "100%",
      height: "100%",
      minHeight: "130px",
      objectFit: "contain",
    },
    text: {
      position: "absolute",
      top: isTable ? "60%" : isPhone ? "55%" : "60%",
      left: "50%",
      transform: "translate(-50%, 0)",
      textAlign: "center",
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      marginBottom: isPhone ? "30px" : "10px",
      fontSize: isTable ? "3rem" : isPhone ? "1.5rem" : "0.75rem",
    },
    subTitle: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      fontSize: isTable ? "1.5rem" : isPhone ? "0.75rem" : "0.5rem",
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.backBox}>
      <Grid>
        <img
          src="/assets/images/News/titleBackGround.png"
          className={classes.titleImg}
        />
      </Grid>
      <Grid className={classes.text}>
        <Typography className={classes.title}>NEWS</Typography>
        <Typography className={classes.subTitle}>最新消息</Typography>
      </Grid>
      <Grid></Grid>
    </Box>
  );
}

//ANCHOR 最新消息內容
function NewsContent() {
  const Alert = useAlert();
  const theme = useTheme();
  const history = useHistory();
  const [getArticle, { data, loading }] = useLazyQuery(GET_ARTICLE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  useEffect(() => {
    if (Boolean(history.location.state.id)) {
      getArticle({ variables: { id: history.location.state.id } });
    } else {
      return null;
    }
  }, [history.location.state.id]);
  const isTablet = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:576px)");
  const [open, setOpen] = useState(false);
  const useStyles = makeStyles((theme) => ({
    backBox: {
      height: "100%",
      minHeight: "600px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      "& .MuiTypography-h6": {
        marginBottom: "30px",
        fontWeight: "bold",
      },
      "& .MuiTypography-subtitle1": {
        marginBottom: "30px",
      },
      "& .MuiTypography-subtitle2": {
        marginBottom: "30px",
      },
    },
    image: {
      width: "100%",
      marginBottom: "30px",
    },
    socialBtns: {
      display: "flex",
      alingItems: "center",
    },
    svgIcons: {
      width: "50px",
      height: "50px",
      transition: "all 0.3s",
      "&:hover": {
        transform: "translateY(-5px)",
      },
    },
    weChatBox: {
      "& .st-btn": {
        display: "block" + "!important",
      },
    },
  }));
  const classes = useStyles();
  function getType(value) {
    switch (value) {
      case "MEDIA_COVERAGE":
        return "媒體報導";
      case "GLORY":
        return "富屋榮耀";
      case "ANNOUNCEMENT":
        return "富屋豹報";
      default:
        return null;
    }
  }

  const socialMedias = [
    {
      label: "facebook",
      svg: FbIcon,
      href: "javascript:;",
    },
    {
      label: "whatsApp",
      svg: WhatsApp,
      href: "javascript:;",
    },
    {
      label: "weChat",
      svg: WeChatIcon,
      href: "javascript:;",
    },
    {
      label: "Line",
      svg: LineIcon,
      href: "javascript:;",
    },
  ];

  return (
    <Box p={4}>
      <Grid container className={classes.backBox}>
        <Grid item xs={11}>
          <hr style={{ marginTop: "20px", backgroundColor: "black" }} />
          <Typography variant="subtitle2">
            {getType(data?.article.type) +
              "\u2002" +
              moment(data?.article.createdAt).format("YYYY/MM/DD HH:mm")}
          </Typography>
          <Typography
            variant={isTablet ? "h6" : "h4"}
            style={{ paddingBottom: "10px" }}
          >
            {data?.article.title}
          </Typography>
          {data?.article.contents.map((item, index) => (
            <Grid key={index} container item direction="column">
              <ContentArea data={item} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="center"
        spacing={0}
        style={{ paddingTop: "28px", alignItems: "center" }}
      >
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.replace("/news/report");
            }}
            style={{ height: isTablet ? "32px" : "" }}
          >
            <Typography variant="caption">返回</Typography>
          </Button>
        </Grid>
        <Grid
          container
          justifyContent="center"
          item
          xs={12}
          style={{ paddingTop: "24px" }}
        >
          <Grid item xs={12}>
            <Box mb={3}>
              <Typography
                variant="caption"
                component="p"
                align="center"
                color="textSecondary"
              >
                分享文章
              </Typography>
            </Box>
          </Grid>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <FacebookShareButton
                url={
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/" +
                  window.location.pathname
                }
              >
                {/* <IconButton color="primary" className={classes.socialIconBtns}> */}
                <Box className={classes.socialBtns}>
                  {createElement(socialMedias[0].svg, {
                    className: classes.svgIcons,
                  })}
                </Box>
                {/* </IconButton> */}
              </FacebookShareButton>
            </Grid>
            <Grid item>
              <WhatsappShareButton
                url={
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/" +
                  window.location.pathname
                }
              >
                <Box className={classes.socialBtns}>
                  {createElement(socialMedias[1].svg, {
                    className: classes.svgIcons,
                  })}
                </Box>
              </WhatsappShareButton>
            </Grid>
            <Grid item>
              <LineShareButton
                url={
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/" +
                  window.location.pathname
                }
              >
                <Box className={classes.socialBtns}>
                  {createElement(socialMedias[3].svg, {
                    className: classes.svgIcons,
                  })}
                </Box>
              </LineShareButton>
            </Grid>
            <Grid item className={classes.weChatBox}>
              <InlineShareButtons
                config={{
                  alignment: "center", // alignment of buttons (left, center, right)
                  color: "social", // set the color of buttons (social, white)
                  enabled: true, // show/hide buttons (true, false)
                  labels: "cta", // button labels (cta, counts, null)
                  language: "zh", // which language to use (see LANGUAGES)
                  networks: ["wechat"],
                  padding: 12, // padding within buttons (INTEGER)
                  radius: "50%", // the corner radius on each button (INTEGER)
                  size: 50, // the size of each button (INTEGER)

                  // OPTIONAL PARAMETERS
                  url:
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/" +
                    window.location.pathname, // (defaults to current url)
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

// ANCHOR 內容區域
function ContentArea({ data }) {
  switch (data.type) {
    case "HEADING":
      return <Title>{data.body}</Title>;
    case "PARAGRAPH":
      return <Paragraph>{data.body}</Paragraph>;
    case "IMAGE":
      return <Image src={data.body} />;
    case "YOUTUBE_VIDEO":
      return <Video src={data.body} />;
    default:
      return null;
  }
}
// ANCHOR 標題
function Title({ children }) {
  const classes = useStyles();
  return (
    <Typography variant="h6" align="center" className={`${classes.textBase}`}>
      {children}
    </Typography>
  );
}
// ANCHOR 內文
function Paragraph({ children }) {
  const classes = useStyles();
  return (
    <Typography
      paragraph
      className={`${classes.textBase} ${classes.paragraph}`}
    >
      &emsp;&emsp;
      {children.split("\n").map((item, index) => (
        <Fragment key={index}>{item}</Fragment>
      ))}
    </Typography>
  );
}
// ANCHOR 圖片
function Image({ src }) {
  const classes = useStyles();
  return <img src={src} className={classes.image} />;
}
// ANCHOR 影片
function Video({ src }) {
  const classes = useStyles();
  let embedUrl = "";
  if (src) {
    if (src.startsWith("http://") || src.startsWith("https://")) {
      if (src.search("embed") === -1) {
        if (src[8] === "w") {
          src = src.split("watch?v=")[1].split("&")[0];
        } else {
          src = src.split("youtu.be/")[1];
        }
      } else {
        embedUrl = src;
      }
    } else {
      return null;
    }
  }
  return (
    <AspectRatio w={16} h={9} className={classes.image}>
      <iframe
        width="100%"
        height="100%"
        src={embedUrl || "https://www.youtube.com/embed/" + src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture fullscreen"
        frameborder="0"
        allowfullscreen
      />
    </AspectRatio>
  );
}
